// @unocss-include
import { useBreakpoints } from '@daysmart/daysmart-vue-components/composables'

const widgetHeight = 0
const tabletHeight = 76
const mobileHeight = 48

function createInstance() {
  const { isWidget } = useWidgetSettings()
  const height = computed(() => {
    const { higherThan } = useBreakpoints()

    if (isWidget)
      return widgetHeight
    if (higherThan.value('sm'))
      return tabletHeight
    return mobileHeight
  })
  const heightPx = computed(() => `${height.value}px`)
  const headerHeightClasses = 'lt-md:h-48px md:h-76px'
  const topMarginClasses = isWidget ? 'mt-0' : 'lt-md:mt-48px md:mt-76px'
  const topPositionClasses = isWidget ? 'top-0' : 'lt-md:top-48px md:top-76px'
  return {
    height,
    heightPx,
    headerHeightClasses,
    topMarginClasses,
    topPositionClasses,
  }
}

export const useHeaderConfig = useSingleton(createInstance)
